import { CloseOutlined } from '@ant-design/icons'
import { Popup } from 'antd-mobile'
import React, { useEffect, useState } from 'react'

export default function HarmonyDownload(props) {

  const [visible,setVisible] = useState(false)

  useEffect(() => {
    setVisible(props?.visible)
    if (props.visible){
      setTimeout(() => {
        if (props.handleDownload){
          props.handleDownload()
        }
      }, 2000);
    }
  },[props?.visible])

  return (
    <Popup
      visible={visible}
      bodyStyle={{
        borderTopLeftRadius: '13px',
        borderTopRightRadius: '13px',
        padding: '15px 15px 0'
      }}>
      <div style={{position:'relative',marginTop:'30px'}}>
      <CloseOutlined onClick={()=>{
        if (props.visibleChange){
          props.visibleChange()
        }
      }} style={{position:'absolute',top:'-40px',right:'-10px',padding:'10px',zIndex:'1',color:'#999'}}></CloseOutlined>
        <div style={{padding:'15px',backgroundColor:'#f5f6f8',textAlign:'center'}}>因鸿蒙系统暂不支持安装游戏apk包<br></br><span style={{color:'red'}}>下载完成后请选择使用卓易通打开</span></div>
        <div>
          <div style={{color:'#282828',fontSize:'13px',padding:'15px 0',fontWeight:'500'}} >1、点击游戏下载按钮后，选择”仍要下载“开始下载游戏；</div>
          <img src="resources/harmony-download1.png" alt="" />
          <div style={{color:'#282828',fontSize:'13px',padding:'15px 0',fontWeight:'500'}} >2、游戏下载完成后，前往下载管理中查看；</div>
          <img src="resources/harmony-download2.png" alt="" />
          <div style={{color:'#282828',fontSize:'13px',padding:'15px 0',fontWeight:'500'}} >3、选择已下载的游戏，点击打开选择使用”卓易通“方式打开即可；<span style={{color:'red'}}>如未安装卓易通请前往华为应用市场下载；</span></div>
          <img src="resources/harmony-download3.png" alt="" />
        </div>
      </div>
    </Popup>
  )
}
